import React from 'react';

const Video = ({ color = '#CCCDCF', size = 35 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20">
    <path
      d="M7.157 3h3.5797L8.6116 5.6783H5.0319L7.157 3zM5.9764 3L3.8512 5.6783H2V4c0-.5523.4477-1 1-1h2.9764zm9.3884 0l-2.1251 2.6783H9.7922L11.9174 3h3.4474zm1.1807 0H17c.5523 0 1 .4477 1 1v1.6783h-3.5797L16.5455 3zM18 6.5304V16c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1V6.5304h16zM8.6116 9.499v4.0332a.4.4 0 0 0 .6147.3375l3.1696-2.0166a.4.4 0 0 0 0-.675L9.2263 9.1615a.4.4 0 0 0-.6147.3375z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default Video;
